// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: import.meta.env.VITE_APP_API_KEY,
    authDomain: import.meta.env.VITE_APP_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_APP_PROJECT_ID,
    storageBucket: import.meta.env.VITE_APP_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_APP_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_APP_ID,
    measurementId: import.meta.env.VITE_APP_MEASUREMENT_ID,
}

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig)

// Initialize Services
export const auth = getAuth(firebaseApp)
export const firestore = getFirestore(firebaseApp)
export const functions = getFunctions(firebaseApp)
export const storage = getStorage(firebaseApp)

// Connect to Emulators in development
if (import.meta.env.DEV) {
    console.log('🔧 Connecting to Firebase Emulators...')

    // Auth Emulator (default port: 9099)
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    console.log('  ✓ Auth Emulator: localhost:9099')

    // Firestore Emulator (default port: 8080)
    connectFirestoreEmulator(firestore, 'localhost', 8080)
    console.log('  ✓ Firestore Emulator: localhost:8080')

    // Functions Emulator (default port: 5001)
    connectFunctionsEmulator(functions, 'localhost', 5001)
    console.log('  ✓ Functions Emulator: localhost:5001')

    // Storage Emulator (default port: 9199)
    connectStorageEmulator(storage, 'localhost', 9199)
    console.log('  ✓ Storage Emulator: localhost:9199')
}
